module.exports = __webpack_public_path__ + "media/images/applicant/flow-dot-default-ba728d02069ebac3a8b1ec3a697a947f.svg";